import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { AdministratorList } from './AdministratorList'
import { getTheme } from '@/utils/theme'

/**
 * 选择管理员弹窗
 * @param param - 参数
 * @param param.adminIds - 选中的管理员ID
 * @param param.setAdminIds - 修改管理员
 * @returns React.ReactNode
 */
export const AdministratorModal: React.FC<{
  adminIds: number[]
  setAdminIds?: (v: number[]) => void
  visible: boolean
  onClose: () => void
  title?: string
}> = ({ adminIds, setAdminIds, visible, onClose, title }) => {
  const theme = getTheme()
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>(adminIds)

  useEffect(() => {
    visible && setSelectedRowKeys(adminIds)
  }, [adminIds, visible])
  return (
    <Modal
      title={title || '选择管理员'}
      open={visible}
      destroyOnClose={true}
      onCancel={() => {
        onClose()
      }}
      onOk={() => {
        setAdminIds && setAdminIds(selectedRowKeys)
        onClose()
      }}
      okButtonProps={{
        style: {
          backgroundColor: theme.brand._1,
          borderColor: theme.brand._1,
        },
      }}
      width={960}
      bodyStyle={{
        minHeight: '300px',
        maxHeight: '572px',
        padding: '20px 20px',
      }}
    >
      <AdministratorList
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </Modal>
  )
}
